import { useEffect } from "react";
import { useContext } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { group_code } = useParams(); // URL 파라미터에서 group_code 추출
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { setErrorMessage } = useContext(AuthContext);

  console.log("isAuthenticated : ", isAuthenticated);

  // 쿠키에서 그룹 로그인 페이지 확인
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key] = value;
    return acc;
  }, {});
  
  // 기본 리다이렉트 경로 설정 (쿠키 우선, 없으면 홈)
  let redirectPath = cookies.groupLoginPagePath || "/";

  // URL 파라미터에 group_code가 있다면 해당 그룹의 로그인 페이지로 우선 리다이렉트
  if (group_code) {
    redirectPath = `/login/${group_code}`;
  }

  // 인증 상태가 변경될 때만 에러 메시지 설정
  useEffect(() => {
    if (!isAuthenticated) {
      setErrorMessage("인증이 만료되었습니다. 다시 로그인 해주세요.");
    }
  }, [isAuthenticated, setErrorMessage]);

  if (!isAuthenticated) {
    // 로그아웃으로 인한 리다이렉트인지 확인
    const isManualLogout = sessionStorage.getItem("preventRedirect");

    if (isManualLogout) {
      // 수동 로그아웃인 경우 경로 저장 방지 플래그 삭제하고 저장 건너뜀
      sessionStorage.removeItem("preventRedirect");
      sessionStorage.removeItem("redirectPath"); // 혹시 남아있을지 모를 기존 값도 제거
    } else {
      // 현재 URL의 전체 정보(경로 + 쿼리 파라미터)를 저장
      const currentFullPath = `${location.pathname}${location.search}`;
      
      // 세션 스토리지에 저장 (브라우저 탭이 닫히면 삭제됨)
      sessionStorage.setItem("redirectPath", currentFullPath);
    }
    
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;